<template>
  <div
    ref="messagesContent"
    class="messagesContent"
  >
    <div class="messagesContent__wrapper">
      <MessageItem
        v-for="message in messages"
        :key="message.id"
        :message="message"
      ></MessageItem>
    </div>
  </div>
</template>

<script>
import MessageItem from "@/components/records/messages/MessageItem"
import { mapState } from 'vuex'

export default {
  name: "MessagesContent",
  components: {
    MessageItem
  },
  computed: {
    ...mapState({
      messages: state => state.records.currentRecordMessages
    })
  },
  watch: {
    messages: {
      immediate: true,
      handler() {
        this.scrollToEnd()
      }
    }
  },
  methods: {
    scrollToEnd() {
      setTimeout(() => {
        const container = this.$refs.messagesContent
        if (container) {
          container.scrollTop = container.scrollHeight - container.clientHeight
        }
      }, 250)
    }
  }
}
</script>

<style scoped lang="scss">
$c: '.messagesContent';

#{$c} {
  height: 70vh;
  overflow-y: auto;
  padding: 24px;
  overflow-y: scroll;

  &__wrapper {
    display: flex;
    flex-direction: column;
  }
}
</style>